export default __webpack_public_path__ + "static/media/desktop_GPS_white.de30b9b7.svg";